import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

const InfoDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Information</DialogTitle>
    <DialogContent>
      <DialogContentText>
        In the event times page, card colors indicate the following:
        <ul>
          <li><strong style={{ color: '#EF9A9A' }}>Red</strong>: Time meets the Senior Mets standard.</li>
          <li><strong style={{ color: '#A5D6A7' }}>Green</strong>: Time meets the Junior Mets standard but not Senior Mets.</li>
          <li><strong style={{ color: '#90CAF9' }}>Light Blue</strong>: Fastest time, but does not meet either standard.</li>
          <li><strong>Default</strong>: Time does not meet any standard and is not the fastest.</li>
        </ul>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default InfoDialog;